module.exports = __webpack_public_path__ + "static/round-lake-map-default-e8d9238ce0cf1dbd02ada4478818f7b7.jpg";